export const logisticsQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "Workers are carrying boxes in a warehouse.",
      B: "Workers are assembling furniture.",
      C: "A delivery truck is being unloaded.",
      D: "A worker is scanning a barcode.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 작업자들이 창고에서 상자를 운반하고 있음\n" +
      "오답 설명: (B) 가구를 조립하지 않음, (C) 트럭에서 하역하지 않음, (D) 바코드를 스캔하지 않음",
  },
  {
    questionNumber: 2,
    choices: {
      A: "A woman is sealing a box with tape.",
      B: "A man is moving pallets with a forklift.",
      C: "A cardboard box is being labeled.",
      D: "A woman is grasping a clipboard.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 여성이 클립보드를 들고 있음\n" +
      "오답 설명: (A) 상자를 테이프로 봉하지 않음, (B) 지게차로 팔레트를 옮기지 않음, (C) 상자에 라벨을 붙이지 않음",
  },
  {
    questionNumber: 3,
    choices: {
      A: "The worker is sealing a box with packing tape.",
      B: "A man is moving a pallet using a hand pallet truck.",
      C: "A forklift is lifting several heavy packages.",
      D: "Some workers are assembling wooden shelves.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남성이 핸드 팔레트 트럭으로 팔레트를 이동하고 있음\n" +
      "오답 설명: (A) 상자를 테이프로 봉하지 않음, (C) 포크리프트를 사용하지 않음, (D) 선반을 조립하지 않음",
  },
  {
    questionNumber: 4,
    choices: {
      A: "The worker is stacking boxes on a shelf.",
      B: "A man is sealing a package with tape.",
      C: "Several employees are organizing a warehouse.",
      D: "A worker is pulling a pallet jack in a warehouse.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 작업자가 창고에서 팔레트 잭을 끌고 있음\n" +
      "오답 설명: (A) 상자를 선반에 쌓지 않음, (B) 소포를 테이프로 봉하지 않음, (C) 여러 명이 창고를 정리하지 않음",
  },
  {
    questionNumber: 5,
    choices: {
      A: "A worker is bending down to lift a box.",
      B: "A worker is pushing a cart down an aisle.",
      C: "A worker is sealing a package with tape.",
      D: "A worker is climbing a ladder.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 작업자가 상자를 들기 위해 허리를 숙이고 있음\n" +
      "오답 설명: (B) 카트를 밀고 있지 않음, (C) 상자를 테이프로 봉하지 않음, (D) 사다리를 오르지 않음",
  },
  {
    questionNumber: 6,
    choices: {
      A: "A worker is stacking boxes on a pallet.",
      B: "A worker is sealing a package with tape.",
      C: "A worker is scanning a barcode on a package.",
      D: "A worker is driving a forklift.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 작업자가 패키지의 바코드를 스캔하고 있음\n" +
      "오답 설명: (A) 상자를 쌓지 않음, (B) 테이프로 봉하지 않음, (D) 지게차를 운전하지 않음",
  },
  {
    questionNumber: 7,
    choices: {
      A: "A worker is unloading boxes by hand.",
      B: "A worker is operating a forklift.",
      C: "A worker is stacking shelves in a warehouse.",
      D: "A worker is sealing a package with tape.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 작업자가 지게차를 운전하고 있음\n" +
      "오답 설명: (A) 손으로 상자를 내리지 않음, (C) 선반에 물건을 쌓지 않음, (D) 테이프로 포장하지 않음",
  },
  {
    questionNumber: 8,
    choices: {
      A: "A delivery truck is being washed.",
      B: "A forklift is being repaired.",
      C: "A package is being lifted into a van.",
      D: "A worker is closing the truck's door.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 화물이 밴에 실리고 있음\n" +
      "오답 설명: (A) 트럭을 세차하지 않음, (B) 지게차를 수리하지 않음, (D) 트럭 문을 닫지 않음",
  },
  {
    questionNumber: 9,
    choices: {
      A: "Workers are transferring packages from a vehicle.",
      B: "A man is taping a cardboard box shut.",
      C: "Several employees are taking inventory inside a warehouse.",
      D: "A worker is using a forklift to move some crates.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 작업자들이 차량에서 상자를 옮기고 있음\n" +
      "오답 설명: (B) 상자를 테이프로 봉하지 않음, (C) 재고 조사를 하지 않음, (D) 지게차를 사용하지 않음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "A woman is placing a parcel on a table.",
      B: "A man is loading boxes into a truck.",
      C: "A recipient is signing for a parcel.",
      D: "A worker is scanning a barcode on a package.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 수령인이 소포 수령 서명을 하고 있음\n" +
      "오답 설명: (A) 소포를 테이블에 놓지 않음, (B) 트럭에 상자를 싣지 않음, (D) 바코드를 스캔하지 않음",
  },

  {
    questionNumber: 11,
    choices: {
      A: "A parcel is being delivered to a customer.",
      B: "A parcel is being placed on a shelf.",
      C: "A parcel is being sealed with tape.",
      D: "A parcel is being opened.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 소포가 테이프로 봉해지고 있음\n" +
      "오답 설명: (A) 고객에게 배달하지 않음, (B) 선반에 놓지 않음, (D) 소포를 열지 않음",
  },
  {
    questionNumber: 12,
    choices: {
      A: "A parcel is being opened.",
      B: "A parcel is being loaded onto a truck.",
      C: "A shipping label is being attached to a parcel.",
      D: "A parcel is being scanned with a barcode reader.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 소포에 배송 라벨이 부착되고 있음\n" +
      "오답 설명: (A) 소포를 열지 않음, (B) 트럭에 싣지 않음, (D) 바코드를 스캔하지 않음",
  },
  {
    questionNumber: 13,
    choices: {
      A: "Workers are sealing boxes with tape.",
      B: "Workers are carrying boxes outside.",
      C: "Workers are unloading furniture from a truck.",
      D: "Workers are packing items into boxes.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 작업자들이 물품을 상자에 포장하고 있음\n" +
      "오답 설명: (A) 상자를 테이프로 봉하지 않음, (B) 상자를 밖으로 운반하지 않음, (C) 트럭에서 가구를 내리지 않음",
  },

  {
    questionNumber: 14,
    choices: {
      A: "A worker is stacking boxes on a pallet.",
      B: "A worker is loading a package into a truck.",
      C: "A package is being wrapped in plastic.",
      D: "A package is being delivered to a customer.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 패키지가 플라스틱으로 포장되고 있음\n" +
      "오답 설명: (A) 상자를 팔레트에 쌓지 않음, (B) 트럭에 싣지 않음, (D) 고객에게 배달하지 않음",
  },
  {
    questionNumber: 15,
    choices: {
      A: "The woman is walking outside the warehouse.",
      B: "The worker is looking inside a storage bin.",
      C: "The woman is carrying a heavy load.",
      D: "The worker is sitting at a desk.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 작업자가 보관함 안을 들여다보고 있음\n" +
      "오답 설명: (A) 창고 밖을 걷고 있지 않음, (C) 무거운 짐을 운반하지 않음, (D) 책상에 앉아있지 않음",
  },
  {
    questionNumber: 16,
    choices: {
      A: "The workers are assembling a machine.",
      B: "A man is cleaning the storage container.",
      C: "Some workers are walking through the warehouse.",
      D: "The workers are checking stock levels.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 작업자들이 재고 수준을 확인하고 있음\n" +
      "오답 설명: (A) 기계를 조립하지 않음, (B) 보관 용기를 청소하지 않음, (C) 창고를 걸어다니지 않음",
  },
  {
    questionNumber: 17,
    choices: {
      A: "The worker is lifting a heavy box.",
      B: "A ladder is lying on the ground.",
      C: "The worker is organizing documents.",
      D: "A helmet has been put on.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 헬멧이 착용되어 있음\n" +
      "오답 설명: (A) 무거운 상자를 들어올리지 않음, (B) 사다리가 바닥에 놓여있지 않음, (C) 서류를 정리하지 않음",
  },
  {
    questionNumber: 18,
    choices: {
      A: "The worker is stacking some boxes.",
      B: "The woman is holding a box.",
      C: "The worker is sealing a package.",
      D: "The woman is pushing a cart.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여성이 상자를 들고 있음\n" +
      "오답 설명: (A) 상자를 쌓고 있지 않음, (C) 패키지를 봉인하고 있지 않음, (D) 카트를 밀고 있지 않음",
  },
  {
    questionNumber: 19,
    choices: {
      A: "The man is stacking some boxes.",
      B: "The man is pushing a cart.",
      C: "The man is walking across the warehouse.",
      D: "The man is crouching down to pick up a box.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 남자가 상자를 집으려고 쭈그리고 앉아있음\n" +
      "오답 설명: (A) 상자를 쌓고 있지 않음, (B) 카트가 보이지 않음, (C) 창고를 가로질러 걷고 있지 않음",
  },
  {
    questionNumber: 20,
    choices: {
      A: "The worker is sealing a box.",
      B: "The man is unloading boxes from a truck.",
      C: "The worker is carrying a package.",
      D: "The man is placing a box on a shelf.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 남자가 선반에 상자를 올려놓고 있음\n" +
      "오답 설명: (A) 상자를 봉인하고 있지 않음, (B) 트럭에서 상자를 내리고 있지 않음, (C) 패키지를 운반하고 있지 않음",
  },
  {
    questionNumber: 21,
    choices: {
      A: "The worker is bending down to pick up a box.",
      B: "The man is walking through the warehouse.",
      C: "The worker is reaching up.",
      D: "The man is taping a package.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 작업자가 위쪽으로 손을 뻗고 있음\n" +
      "오답 설명: (A) 상자를 집으려고 몸을 굽히고 있지 않음, (B) 창고를 걷고 있지 않음, (D) 패키지를 테이프로 봉인하고 있지 않음",
  },
  {
    questionNumber: 22,
    choices: {
      A: "The worker is bending down to pick up a box.",
      B: "The man is stacking boxes on the ground.",
      C: "The worker is being lifted by a forklift.",
      D: "The man is sealing a package with tape.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 작업자가 지게차에 의해 들어올려지고 있음\n" +
      "오답 설명: (A) 상자를 집으려고 몸을 굽히고 있지 않음, (B) 바닥에 상자를 쌓고 있지 않음, (D) 테이프로 패키지를 봉인하고 있지 않음",
  },
  {
    questionNumber: 23,
    choices: {
      A: "The worker is unloading boxes from a truck.",
      B: "The forklift is transporting boxes.",
      C: "The man is repairing a forklift.",
      D: "The worker is stacking packages on the ground.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 지게차가 상자들을 운반하고 있음\n" +
      "오답 설명: (A) 트럭에서 상자를 내리고 있지 않음, (C) 지게차를 수리하고 있지 않음, (D) 바닥에 패키지를 쌓고 있지 않음",
  },
];
